<template>
  <div class="container">
    <template v-if="showType === 'new'">
      <new-version />
    </template>
    <template v-else>
      <old-version />
    </template>
  </div>
</template>

<script>
import OldVersion from '@/pages/project/version/old';
import NewVersion from '@/pages/project/version/new';

export default {
  components: { OldVersion, NewVersion },
  data() {
    return {
      showType: 'new'
    };
  }
};
</script>
